import React, { useEffect, useState } from "react";
import { Calendar, User, ArrowRight } from "lucide-react";
import "./blog.css";

export default function Blog() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const categories = [
    { id: "all", name: "All Posts" },
    { id: "packaging-tips", name: "Packaging Tips" },
    { id: "sustainability", name: "Sustainability" },
    { id: "industry-insights", name: "Industry Insights" },
    { id: "custom-design", name: "Custom Design" },
    { id: "product-guides", name: "Product Guides" },
  ];

  const [activeCategory, setActiveCategory] = useState("all");

  const blogPosts = [
    {
      id: 2,
      title: "Custom Boxes & Packaging Solutions",
      excerpt:
        "Discover everything about custom boxes and packaging solutions—from creative design ideas to eco-friendly materials and branding strategies",
      category: "sustainability",
      author: "Krishna Chaudhari",
      date: "2025-08-25",
      readTime: "7 min read",
      image:
        "https://rigidboxes.in/wp-content/uploads/2024/10/custom-packaging-boxes-for-small-business-1024x585.jpg",
    },
    {
      id: 3,
      title: "Sweet Success: Packaging Confectionery Products",
      excerpt:
        "From chocolates to candies, discover the best packaging solutions that keep your sweet treats fresh and appealing to customers.",
      category: "product-guides",
      author: "Darshan Deshmukh",
      date: "2025-08-22",
      readTime: "4 min read",
      image:
        "https://i.etsystatic.com/24129554/r/il/2116f9/4790645839/il_570xN.4790645839_20xf.jpg",
    },
    {
      id: 4,
      title: "Saree Box Packaging Ideas",
      excerpt:
        "Elegant saree boxes with creative designs, durable packaging, and stylish presentation to protect, preserve, and enhance your traditional attire.",
      category: "custom-design",
      author: "Tejas Jagdale",
      date: "2025-08-20",
      readTime: "6 min read",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTYmpq-ZQQnQdD1MD9nP8VVTa8vsiE2DqqvQA&s",
    },
    {
      id: 5,
      title: "Custom Cake Box Designs & Trends",
      excerpt:
        "Discover stylish and durable cake box packaging solutions that keep your cakes fresh and beautifully presented. Explore creative designs, eco-friendly options, and branding ideas",
      category: "industry-insights",
      author: "Sunder Pichai",
      date: "2025-08-18",
      readTime: "8 min read",
      image:
        "https://www.tricity24.com/cdn/shop/files/71LXDFnVLYL._SL1500_1024x1024.jpg?v=1682510989",
    },
    {
      id: 6,
      title: "Smart Electronic Packaging Solutions",
      excerpt:
        "Explore innovative electronic box packaging solutions designed for durability, safety, and style. Discover custom designs, eco-friendly materials, and branding ideas for electronics.",
      category: "sustainability",
      author: "Krishna Chaudhari",
      date: "2025-08-15",
      readTime: "5 min read",
      image:
        "https://5.imimg.com/data5/PD/NB/DP/SELLER-4562344/electronic-goods-packaging-box.jpg",
    },
    {
      id: 7,
      title: "Strong & Reliable Carton Box Packaging",
      excerpt:
        "Discover durable and eco-friendly carton box packaging solutions for shipping, storage, and branding. Explore custom designs.",
      category: "product-guides",
      author: "Rohit Sharma",
      date: "2025-08-12",
      readTime: "6 min read",
      image:
        "https://media.istockphoto.com/id/1363734940/photo/three-cardboard-boxes.jpg?s=612x612&w=0&k=20&c=Qj6K1O9O0C3afPCrCGJzR_8MRlxSgpfSs24hvVjxaq0=",
    },
    {
      id: 8,
      title: "Perfume Box Trends & Branding Ideas",
      excerpt:
        "Explore elegant and stylish perfume box packaging solutions designed to enhance beauty, protect bottles, and strengthen branding. Discover luxury designs, eco-friendly options, and creative ideas.",
      author: "Aarav Patel",
      date: "2025-08-10",
      readTime: "5 min read",
      category: "custom-design",
      image:
        "https://5.imimg.com/data5/SELLER/Default/2022/10/WH/ME/XQ/8496781/perfume-packaging-boxes-250x250.jpg",
    },
    {
      id: 9,
      title: "Durable Mobile Box Packaging Solutions",
      excerpt:
        "Explore innovative mobile box packaging solutions designed for safety, durability, and style. Discover custom designs.",
      category: "industry-insights",
      author: "Om Mehta",
      date: "2025-08-08",
      readTime: "9 min read",
      image:
        "https://bellprinters.com/wp-content/uploads/2021/03/Electronic-device-Packaging-Boxes-web-3-1.jpg",
    },
    {
      id: 10,
      title: "Premium Chocolate Boxes: Elegant Packaging for Freshness and Gifting",
      excerpt:
        "From luxury pralines to homemade delights, discover stylish chocolate box packaging that ensures freshness, enhances presentation, and delights customers.",
      category: "custom-design",
      author: "Karn Singh",
      date: "2025-08-05",
      readTime: "6 min read",
      image:
        "https://img.kwcdn.com/product/Fancyalgo/VirtualModelMatting/ed3951e6bd154a714a4a81a5fa8ff852.jpg?imageView2/2/w/500/q/60/format/webp",
    },
  ];
  const filtered =
    activeCategory === "all"
      ? blogPosts
      : blogPosts.filter((p) => p.category === activeCategory);

  const featuredPost = activeCategory === "all" ? filtered[0] : null;
  const regularPosts = activeCategory === "all" ? filtered.slice(1) : filtered;

  return (
    <div className="blog-container">
      {/* ── CATEGORY FILTER ── */}

      {/* ── CATEGORY FILTER ── */}
      <div className="blog-filter-bar">
        {categories.map((cat) => (
          <button
            key={cat.id}
            className={`filter-chip ${activeCategory === cat.id ? "active" : ""}`}
            onClick={() => setActiveCategory(cat.id)}
          >
            {cat.name}
          </button>
        ))}
      </div>

      {/* ── MAIN CONTENT ── */}
      <div className="blog-grid-wrapper">
        <div className="blog-grid">
          {/* Featured Post */}
          {featuredPost && (
            <article className="featured-post">
              <div className="featured-image-wrapper">
                <img src={featuredPost.image} alt={featuredPost.title} />
              </div>
              <div className="featured-content">
                <span className="featured-badge">Featured Story</span>
                <h3 className="featured-title">{featuredPost.title}</h3>
                <p className="featured-excerpt">{featuredPost.excerpt}</p>
                <div className="blog-footer">
                  <button className="read-more-btn">
                    Read the Story <ArrowRight size={20} />
                  </button>
                </div>
              </div>
            </article>
          )}

          {/* Regular Posts */}
          {regularPosts.map((post) => (
            <article key={post.id} className="blog-card">
              <div className="blog-image-wrapper">
                <img src={post.image} alt={post.title} loading="lazy" />
                <span className="blog-category-badge">
                  {categories.find((c) => c.id === post.category)?.name || "Packaging"}
                </span>
              </div>

              <div className="blog-content">
                <h3 className="blog-title">{post.title}</h3>
                <p className="blog-excerpt">{post.excerpt}</p>

                <div className="blog-meta">
                  <div className="blog-meta-item">
                    <User size={13} />
                    <span>{post.author}</span>
                  </div>
                  <div className="blog-meta-item">
                    <Calendar size={13} />
                    <span>
                      {new Date(post.date).toLocaleDateString("en-GB", {
                        day: "numeric",
                        month: "short",
                        year: "numeric",
                      })}
                    </span>
                  </div>
                </div>

                <div className="blog-footer">
                  <span className="read-time-tag">{post.readTime}</span>
                  <button className="read-more-btn">
                    Read More <ArrowRight size={15} />
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}